import { Component } from 'react';
import AGContext from './context';

class AGProvider extends Component {
  constructor() {
    super();
    this.state = {
      collectGrids: {
        registerGrid: this.registerGrid,
        unregisterGrid: this.unregisterGrid,
      },
      grids: [],
    };
  }

  registerGrid = (grid) => {
    const gridsLength = this.state.grids.length;
    this.setState({ grids: [grid] });
    return gridsLength;
  };

  // Consumers call into every registered grid, so a grid that is gone has to drop
  // out of the list -- its api throws once the grid is destroyed.
  unregisterGrid = (grid) => {
    this.setState(({ grids }) => ({ grids: grids.filter((item) => item !== grid) }));
  };

  render() {
    return (
      <AGContext.Provider
        value={{
          ...this.state,
        }}
      >
        {this.props.children}
      </AGContext.Provider>
    );
  }
}

export default AGProvider;
